module.exports = __webpack_public_path__ + "static/media/washingtonposr.e7d6bf7b.png";